const getDatePartOfStamp = (date) => {
  if (date.length === 10) return date;

  return (
    ("0" + (date.month() + 1)).slice(-2) +
    "/" +
    ("0" + date.date()).slice(-2) +
    "/" +
    date.year()
  );
};

export default getDatePartOfStamp;
